import { Dispatch } from '../../../../../types/actions';
import { SnackbarVariant, ISnackbarControlModel } from '../../store/types';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_BUTTON_RELOAD, SNACKBAR_ID_RELOAD, SNACKBAR_BUTTON_CLOSE } from '../constants';
import { SNACKBAR_RELOAD_TEXT } from './constants';
import { getReloadActionEvent } from '../helpers/getReloadActionEvent';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';

export const snackbarErrorReload = (
    isClosable: boolean = true,
    text: string =  SNACKBAR_RELOAD_TEXT
) => {
    return (dispatch: Dispatch) => {
        const closeControl = {
            onClick: () => dispatch(getDefaultActionEvent(SNACKBAR_ID_RELOAD)),
            text: SNACKBAR_BUTTON_CLOSE
        };
        const reloadControl = {
            onClick: getReloadActionEvent(),
            isPrimary: true,
            text: SNACKBAR_BUTTON_RELOAD
        };
        const buttons: ISnackbarControlModel[] = [ reloadControl ];
        if (isClosable) buttons.unshift(closeControl);
        dispatch(addUpdateSnackbarWithBubble({
            id: SNACKBAR_ID_RELOAD,
            buttons,
            text: SNACKBAR_RELOAD_TEXT,
            icon: 'error',
            title: null,
            variant: SnackbarVariant.RELOAD
        }));
    }
};
